import $ from "jquery";
import DepartTab from "./components/departTab";
import DepartUserTab from "./components/departUserTab";
import GroupUserTab from "./components/groupUserTab";
import JobLevelTab from "./components/jobLevelTab";
import JobLevelUserTab from "./components/joblevelUserTab";
import OutPersonTab from "./components/outUnitUserTabs";
import RecentUserTab from "./components/recentUserTab";
import RelPersonTab from "./components/relPersonTab";
import RoleTab from "./components/roleTab";
import RoleUserTab from "./components/roleUserTab";
import StationTab from "./components/stationTab";
import UnitTab from "./components/unitTab";
import StationUserTab from "./components/stationUserTab";
import OutUnitTab from "./components/outUnitTabs";
import ManageUserTab from "./components/manageUserTab";
import {AssertUtils} from "goingutils";
//窗口相关的工具类
import WinUtils from '../../winUtils';

class GoAclDialog {
    constructor(parentId, options, vueObj) {
        let newIds=[];
        //对排除对id集合 进行下特殊处理
        if(options.excludeIds!=null){
            options.excludeIds.forEach((rowId)=>{
                if(rowId.indexOf("_")){
                    newIds.push(rowId.split("_")[0]);
                }
            });
            options.excludeIds=newIds;
        }
        this.params = options.params;
        this.initFun = options.initFun;
        this.parentId = parentId;
        this.excludeIds=options.excludeIds;
        this.options = options;
        this.vueObj = vueObj;
        this.count = 1000;

        if (AssertUtils.isNotEmpty(options.count)) {
            this.count = options.count;
        }
        this.tabFactory = {};
        this.initContainer();
        this.initTabFactory();
        this.addAclTabs();
        //初始化tab的事件
        this.initTabEvent();
    }

    destruction() {
        console.log("销毁acl内存，===================");
        let dialogObj = this;
        if(this.options.tabs==null){
            this.options.tabs=[
                { id: "departUser", active: true, accountSel: false },
                { id: "roleUser", active: false, accountSel: false },
            ];
        }
        //循环tabs来生成相应的tab对象
        this.options.tabs&&this.options.tabs.forEach(function (item) {
            //获取tabcell对象
            let tabCellObj = dialogObj.tabFactory[item.id];
            if (AssertUtils.isFunction(tabCellObj.destructionTab)) {
                tabCellObj.destructionTab();
            }
        });
        this.tabFactory = null;
        for (let c in this) {

            this[c] = null;
        }
        dialogObj = null;
    }

    /**
     * 获取返回的结果{ids：'',names:''}
     * @returns {*}
     */
    getBackResult() {
        let returnObj = this.activeCell.getBackResult();
        return returnObj["names"];
    }

    /**
     * 获取返回的名称
     * @returns {*}
     */
    getBackInfos(count, suffix) {

        let backFlag = true;
        let {names, ids, dataFroms,dataFromLabels, accountId} = this.activeCell.getBackResult('Array');
        if (!AssertUtils.isNotEmpty(ids[0])) {
            WinUtils.alert("请选择相应数据后再点击确定！");
            backFlag = false;
        }
        //如果设置count 则需要进行校验数量 如果没有设置则不需要进行校验
        if (count != null) {
            if (ids.length > count) {

                WinUtils.alert(
                    "最多只能选择" +
                    count +
                    "项数据，当前已经选择了" +
                    ids.length +
                    "项."
                );
                backFlag = false;
            }
        }
        if(suffix){
            let newNames = [];let newIds=[];
            names.map(function (item, index) {
                //判断是否需要后缀
                if (suffix) {
                    newNames.push(item + "_" + dataFromLabels[index]);
                } else {
                    newNames.push(item);
                }
            });
            ids.map(function (item, index) {
                //判断是否需要后缀
                if (suffix) {
                    newIds.push(item + "_" + dataFroms[index]);
                } else {
                    newIds.push(item);
                }
            });
            return {selIds: newIds, selNames: newNames, accountId: accountId, dataFroms: dataFroms, backFlag};
        }else{
            return {selIds: ids, selNames: names, accountId: accountId, dataFroms: dataFroms, backFlag};
        }
    }

    initTabFactory() {
        //部门
        DepartTab(this, this.vueObj);
        //群组
        GroupUserTab(this, this.vueObj);
        //职务级别
        JobLevelTab(this, this.vueObj);
        //职务级别
        JobLevelUserTab(this, this.vueObj);
        //编外人员
        OutPersonTab(this, this.vueObj);
        //  编外单位
        OutUnitTab(this, this.vueObj);
        //最近人员
        RecentUserTab(this, this.vueObj);
        //关联人员
        RelPersonTab(this, this.vueObj);
        //角色
        RoleTab(this, this.vueObj);
        //角色
        RoleUserTab(this, this.vueObj);
        //岗位
        StationTab(this, this.vueObj);
        //岗位用户
        StationUserTab(this, this.vueObj);
        //单位
        UnitTab(this, this.vueObj);
        //  部门树选择
        DepartUserTab(this, this.vueObj);
        //  管理员tab
        ManageUserTab(this, this.vueObj);
    }

    /**
     * 初始化tab相关事件
     */
    initTabEvent() {
        let goDialog = this;
        $("#" + this.parentId + "_header")
            .find(".ivu-tabs-tab")
            .click(function () {
                let tabId = $(this).attr("tabId");
                let tabCellObj = goDialog.tabFactory[tabId];
                let oldCellObj=goDialog.activeCell;
                //如果当前点击对象 即 目前激活对象 则不需要处理
                if(oldCellObj==tabCellObj){
                    return void(0);
                }
                if (tabCellObj != null) {
                    let tabConfigItem = goDialog.getTabConfig(tabId);
                    tabCellObj.activeCell(goDialog,oldCellObj , tabConfigItem);
                    tabCellObj.initTabState(goDialog.getTabConfig(tabId));
                }
            });
    }

    getTabConfig(tabId) {
        for (var num = 0; num < this.options.tabs.length; num++) {
            var tabsItem = this.options.tabs[num];
            if (tabId === tabsItem["id"]) {
                return tabsItem;
            }
        }
    }

    //追加tabs对象
    addAclTabs() {
        let dialogObj = this;
        //循环tabs来生成相应的tab对象
        this.options.tabs.forEach(function (item) {
            dialogObj.addTabObj(item);
        });
    }

    //将tabCellObj添加到工厂容器中
    addTabToFactory(id, tabCellObj) {
        this.tabFactory[id] = tabCellObj;
    }

    addTabObj(itemConfig) {
        let {id, active} = itemConfig;
        //获取tabcell对象
        let tabCellObj = this.tabFactory[id];
        if (tabCellObj != null) {
            //将cell对象添加到容器中
            this.addTabCell(tabCellObj, itemConfig);
            if (active) {
                tabCellObj.activeCell(this, null, itemConfig);
                //初始化tab页的状态
                tabCellObj.initTabState(itemConfig);
            }
        }
    }

    //添加相应的tabcell
    addTabCell(tabCellObj, itemConfig) {
        if (tabCellObj != null) {
            this.addTabHeader(tabCellObj.getTabHeader());
            this.addTabBody(tabCellObj.getTabBody(this.panelHeight, itemConfig));
        }
    }

    //添加tab的头部
    addTabHeader(htmls) {
        $(htmls).appendTo($("#" + this.parentId + "_header"));
    }

    //添加tab的body
    addTabBody(htmls) {
        $(htmls).appendTo($("#" + this.parentId + "_body"));
    }

    //初始化tab头部容器
    getTabHeaderHtmls() {
        return `<div class="ivu-tabs-nav-scroll" style="background-color: rgb(255, 255, 255); border-bottom: 1px solid rgb(45, 140, 240);">
                  <div class="nav-text ivu-tabs-nav" id="${
            this.parentId
            }_header"> 
                  </div>
           </div>`;
    }

    //初始化tab的body容器
    getTabBodyHtmls() {
        let containerHeight = $("#" + this.parentId).height();
        this.panelHeight = containerHeight - 30;
        return `<div class="ivu-tabs-content"  id="${
            this.parentId
            }_body" style="height: ${parseFloat(containerHeight) - 30}px"></div>`;
    }

    //初始化容器最外层的div
    initContainerBase() {
        $(
            `<div id='${
                this.parentId
                }_acl' class="go-acl-tabs" style="height: 100%;"></div>`
        ).appendTo($("#" + this.parentId));
    }

    //初始化控件容器
    initContainer() {
        //初始化容器的基本信息
        this.initContainerBase();
        let tabHeaderHtmls = this.getTabHeaderHtmls();
        let tabBodyHtmls = this.getTabBodyHtmls();
        //将头部追加到容器中
        $(tabHeaderHtmls).appendTo($("#" + this.parentId + "_acl"));
        //将body追加到容器中
        $(tabBodyHtmls).appendTo($("#" + this.parentId + "_acl"));
    }
}

export default GoAclDialog;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/index.js